import Link from "next/link";

export default function LinkComponent({
  href,
  children,
  className,
  ...props
}: {
  href: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <Link href={href} className={className} {...props}>
      {children}
    </Link>
  );
}
